import {
    getBusin,
    getCls,
    getOrgseparator,
    getFs,
    getMinistry,
    getOkved,
    getOkvedResolution,
} from '@/service/counteragent-service';
import { sortObjectsByName } from '@/utils/sort-comporator';

export default {
    state() {
        return {
            controlsDisabled: false,
            cls: [],
            orgSeparator: [],
            busin: [],
            ministry: [],
            fs: [],
            okved: [],
            okvedResolution: [],
        };
    },
    mutations: {
        setList(state, { nsiName, list }) {
            state[nsiName] = list;
        },
        setControlsDisabled(state, value) {
            state.controlsDisabled = value;
        },
    },
    actions: {
        changeControlDisabled({ commit }, value) {
            commit('setControlsDisabled', value);
        },
        clearNsi({ commit }) {
            commit('setList', { nsiName: 'cls', list: [] });
            commit('setList', { nsiName: 'orgSeparator', list: [] });
            commit('setList', { nsiName: 'busin', list: [] });
            commit('setList', { nsiName: 'ministry', list: [] });
            commit('setList', { nsiName: 'fs', list: [] });
            commit('setList', { nsiName: 'okved', list: [] });
            commit('setList', { nsiName: 'okvedResolution', list: [] });
        },
        async loadClsList({ commit }) {
            const list = await getCls();
            if (list) {
                commit('setList', { nsiName: 'cls', list });
            }
        },
        async loadOrgSeparatorList({ commit }) {
            const list =  await getOrgseparator();
            if (list) {
                commit('setList', { nsiName: 'orgSeparator', list });
            }
        },
        async loadBusinList({ commit }) {
            const list = await getBusin();
            if (list) {
                commit('setList', { nsiName: 'busin', list });
            }
        },
        async loadMinistryList({ commit }) {
            const list = await getMinistry();
            const sortedList = list.sort(sortObjectsByName);
            if (sortedList) {
                commit('setList', { nsiName: 'ministry', list: sortedList });
            }
        },
        async loadFsList({ commit }) {
            const list = await getFs();
            if (list) {
                commit('setList', { nsiName: 'fs', list });
            }
        },
        async loadOkvedList({ commit }) {
            const list = await getOkved();
            if (list) {
                commit('setList', { nsiName: 'okved', list });
            }
        },
        async loadOkvedResolutionList({ commit }) {
            const list = await getOkvedResolution();
            if (list) {
                commit('setList', { nsiName: 'okvedResolution', list });
            }
        },
        /*async loadById(id) {
            const response = await getCustomerCard(id)
            if (response) {
                return { result: true };
            }
            return { result: false, error: response.msg };
        },*/
        /*async saveById(id) {

            var save_args = {kodp: id}
            store.state.userDataDetails.userData.changes.forEach((element) => {
                var newKey = element.field;
                var newVal = element.value;
                save_args[newKey] = newVal;
            })


            const response = await saveCustomerCard(save_args)
            if (response.result) {
                //const state_value = await getCustomerCard(args.kodp)

                return { result: true, error: '' }
            }
            else
                return { result: false, error: response.msg };
        },*/
    },
    getters: {
        getOkvedResolutionFiltered: state => () => state.okvedResolution.filter(row => row.kod_res_okved > 0),
        getOkvedByResolutionId: state => id => state.okved.filter(row => row.kod_res_okved === id),
        getActiveFs: state => () => state.fs.filter(row => !row.arhive),
    },
};
